<template>
  <div class="subtitle-faq">
    <h2 class="section-title">{{ $t('subtitlePage.faq.title') }}</h2>

    <div class="faq-container">
      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item
          v-for="item in questions"
          :key="item.id"
          :name="item.id"
        >
          <template #title>
            <div class="faq-title">
              <Icon name="material-symbols:help" class="faq-icon" />
              <span>{{ item.question }}</span>
            </div>
          </template>
          <div class="faq-answer">
            <p>{{ item.answer }}</p>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const activeNames = ref<string[]>([])

import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const questions = [
  {
    id: 'q1',
    question: t('subtitlePage.faq.items.0.q'),
    answer: t('subtitlePage.faq.items.0.a')
  },
  {
    id: 'q2',
    question: t('subtitlePage.faq.items.1.q'),
    answer: t('subtitlePage.faq.items.1.a')
  },
  {
    id: 'q3',
    question: t('subtitlePage.faq.items.2.q'),
    answer: t('subtitlePage.faq.items.2.a')
  },
  {
    id: 'q4',
    question: t('subtitlePage.faq.items.3.q'),
    answer: t('subtitlePage.faq.items.3.a')
  },
  {
    id: 'q5',
    question: t('subtitlePage.faq.items.4.q'),
    answer: t('subtitlePage.faq.items.4.a')
  },
  {
    id: 'q6',
    question: t('subtitlePage.faq.items.5.q'),
    answer: t('subtitlePage.faq.items.5.a')
  },
  {
    id: 'q7',
    question: t('subtitlePage.faq.items.6.q'),
    answer: t('subtitlePage.faq.items.6.a')
  }
]
</script>

<style scoped lang="scss">
.subtitle-faq {
  padding: $spacing-xxl 0;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  color: $gray-900;
  margin-bottom: $spacing-xl;
}

.faq-container {
  width: 100%;
  max-width: none;
  margin: 0 auto;
}

.faq-title {
  display: flex;
  align-items: center;
  gap: $spacing-md;
  font-size: 1.05rem;
  font-weight: 600;
  color: $gray-900;
  padding: $spacing-sm 0;

  .faq-icon {
    color: #8B5CF6;
    flex-shrink: 0;
  }
}

.faq-answer {
  padding: $spacing-md $spacing-lg;
  color: $gray-700;
  line-height: 1.8;
  font-size: 0.95rem;
  background: linear-gradient(135deg,
    rgba(#8B5CF6, 0.03) 0%,
    rgba(#4A90E2, 0.03) 100%);
  border-radius: $border-radius-md;
  margin-top: $spacing-sm;

  p {
    margin: 0;
  }
}

// Element Plus Collapse样式覆盖
:deep(.el-collapse) {
  border: none;

  .el-collapse-item {
    margin-bottom: $spacing-md;
    background: $white;
    border-radius: $border-radius-lg;
    border: 1px solid $gray-200;
    box-shadow: $shadow-sm;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: $shadow-md;
      border-color: rgba(#8B5CF6, 0.3);
    }
  }

  .el-collapse-item__header {
    padding: $spacing-md $spacing-lg;
    background: transparent;
    border: none;
    font-weight: 600;

    &.is-active {
      border-bottom: 1px solid $gray-200;
    }
  }

  .el-collapse-item__wrap {
    border: none;
    background: transparent;
  }

  .el-collapse-item__content {
    padding: 0 $spacing-lg $spacing-md;
  }

  .el-collapse-item__arrow {
    color: #8B5CF6;
    font-weight: bold;
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 1.75rem;
  }

  .faq-container {
    padding: 0 $spacing-md;
  }

  .faq-title {
    font-size: 0.95rem;
  }

  .faq-answer {
    font-size: 0.9rem;
  }
}
</style>
